.SortableList {

}
.SortableListItem {
	list-style-type: none;
	margin: 0 0 10px;
}